module.exports = __webpack_public_path__ + "img/complex-simulation-icon.6826e1b7.svg";